export default __webpack_public_path__ + "dist/media/logo-eu--en.81e214d9.svg";